/** The Autoclipper watermark is free-plan only: any plan with `no_watermark`
 *  exports clean. The old challenge-participant override was removed
 *  2026-10-01 (mirrors backend isDefaultWatermarkEnabled). */
export function shouldShowFreeWatermark(features: readonly string[] | null | undefined): boolean {
  return !(features ?? []).includes('no_watermark');
}
